import {useEffect, useRef} from "react";
import {useDispatch} from "react-redux";

import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {closeAuthModal, openAuthModal} from "../../auth/store/auth_modal_slice";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";

export interface IFavoriteAuthParams {
    type: "property" | "offer";
}

export const useFavoritesAuth = () => {
    const dispatch = useDispatch();
    const isAuthenticated = useIsAuthenticated();
    const wasAuthenticatedRef = useRef(isAuthenticated);
    const pendingModalCloseRef = useRef(false);

    // Track when user becomes authenticated to handle post-auth actions
    useEffect(() => {
        if (!wasAuthenticatedRef.current && isAuthenticated && pendingModalCloseRef.current) {
            handleAuthSuccess();
        }
        wasAuthenticatedRef.current = isAuthenticated;
    }, [isAuthenticated]);

    const auth = (params: IFavoriteAuthParams) => {
        pendingModalCloseRef.current = true;
        dispatch(
            openAuthModal({
                userSource: params.type === "property" ? UserSource.FAVOURITE_PROPERTY : UserSource.FAVOURITE_OFFER,
                modalVariant: "extended",
                headerVariant: AuthModalVariant.FAVORITE
            })
        );
    };

    const handleAuthSuccess = () => {
        dispatch(closeAuthModal());

        pendingModalCloseRef.current = false;
    };

    return auth;
};
import {useEffect, useRef} from "react";
import {useDispatch} from "react-redux";

import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {closeAuthModal, openAuthModal} from "../../auth/store/auth_modal_slice";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {useIsAuthenticated} from "../../user/hooks/use_is_authenticated";

export interface IFavoriteAuthParams {
    type: "property" | "offer";
}

export const useFavoritesAuth = () => {
    const dispatch = useDispatch();
    const isAuthenticated = useIsAuthenticated();
    const wasAuthenticatedRef = useRef(isAuthenticated);
    const pendingModalCloseRef = useRef(false);

    // Track when user becomes authenticated to handle post-auth actions
    useEffect(() => {
        if (!wasAuthenticatedRef.current && isAuthenticated && pendingModalCloseRef.current) {
            handleAuthSuccess();
        }
        wasAuthenticatedRef.current = isAuthenticated;
    }, [isAuthenticated]);

    const auth = (params: IFavoriteAuthParams) => {
        pendingModalCloseRef.current = true;
        dispatch(
            openAuthModal({
                userSource: params.type === "property" ? UserSource.FAVOURITE_PROPERTY : UserSource.FAVOURITE_OFFER,
                modalVariant: "extended",
                headerVariant: AuthModalVariant.FAVORITE
            })
        );
    };

    const handleAuthSuccess = () => {
        dispatch(closeAuthModal());

        pendingModalCloseRef.current = false;
    };

    return auth;
};
